/**
 * Created by henian.xu on 2018/9/11.
 * 商品模块
 */
import { Buyer } from '@/api/buyer/Buyer';

class Ex extends Buyer {
    constructor() {
        super();
        this.baseUrl += '/ex';
    }
}

export default new Ex();
export { Ex };
